module.exports = __webpack_public_path__ + "img/blue-confirmation-icon.b37145fe.svg";